import {
  Box,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Stack,
  styled,
  Typography,
} from "@mui/material";

import profilePlaceHolder from "assets/media/images/idCard-Images/userImage.png";

import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import appRoutes from "app/config/routes";
import { getStaffByName } from "app/services/schoolService/dashboard.service";
import { Close } from "@mui/icons-material";
import { formatGuardianString } from "app/utils/helper";

const StaffCard = ({ item }) => {
  return (
    <Box
      my={1}
      sx={{
        color: "primary",
      }}
    >
      <Stack direction="row" spacing={1} alignItems={"center"} px={2}>
        {/* staff profile pic */}
        <div>
          <img
            src={item?.profilePic ? item?.profilePic : profilePlaceHolder}
            alt="staff"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        {/* staff details */}
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "15px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {item?.name}
          </Typography>

          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {formatGuardianString(
              item?.gender,
              item?.fatherName || item?.motherName || ""
            )}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Department: {item?.departmentName ?? "Academic"}
          </Typography>
          <Stack direction={"row"} gap={2} alignItems={"center"}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "12px",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              Designation: {item?.designation ?? "teacher"}
            </Typography>

            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "12px",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              Employee ID: {item?.employeeId ?? "AKSIC25"}
            </Typography>
          </Stack>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Gender: {item?.gender}
          </Typography>
        </Stack>
      </Stack>
      <Divider sx={{ background: "rgba(0,0,0,0.3)", mt: 1 }} />
    </Box>
  );
};
const StaffSeachDialogDashboard2 = ({
  isNavigateToProfile = true,
  returnResponse = () => {},
}) => {
  const listRef = useRef(null);
  const [state, setState] = useState({
    name: "",
    page: 1,
    staffData: {},
    menuOpen: false,
    staffDetail: {},
    isFocus: false,
  });
  const {
    isFetching: getStaffByNameFetching,
    isLoading: getStaffByNameLoading,
  } = useQuery({
    queryKey: ["getStaffByName", state.name, state.page],
    queryFn: () =>
      getStaffByName({
        staffName: state.name,
      }),
    onSuccess: (success) => {
      if (Number(state.page) !== 1) {
        setState((prev) => ({
          ...prev,
          staffData: {
            ...prev.staffData,
            ...success?.data,
            list: [...prev?.staffData?.list, ...success?.data?.list],
          },
        }));
      } else {
        setState((prev) => ({ ...prev, staffData: success?.data }));
      }
    },
    onError: ({ response: { data } }) => {
      toast.error(data?.message);
    },
    enabled: state.name ? true : false,
  });
  useEffect(() => {
    if (listRef.current) {
      const scrollDiv = listRef.current;
      setState((prev) => ({
        ...prev,
        scrollPosition: scrollDiv.scrollTop,
      }));
    }
  }, [state.page]);

  useEffect(() => {
    if (listRef.current && Number(state.page) > 1) {
      const scrollDiv = listRef.current;
      scrollDiv.scrollTo({
        top: state.scrollPosition || 0,
      });
    }
  }, [state.page, state.scrollPosition]);
  return (
    <ClickAwayListener
      onClickAway={() => setState((prev) => ({ ...prev, isFocus: false }))}
    >
      <Wrapper>
        <div className="input_box">
          <input
            onFocus={() => setState((prev) => ({ ...prev, isFocus: true }))}
            type="text"
            placeholder="Search staff..."
            value={state.name}
            onChange={(e) => {
              setState((prev) => ({
                ...prev,
                name: e.target.value,
                ...(state.page !== 1 && { page: 1 }),
                ...(!e.target.value && { staffData: {} }),
              }));
            }}
            className="custom_input"
          />
          {state.name && (
            <div
              onClick={() =>
                setState((prev) => ({ ...prev, name: "", staffData: {} }))
              }
            >
              <Close className="close_icon" />
            </div>
          )}
        </div>
        {/* box */}
        {state.name && state.isFocus && (
          <div className="student_box__wrapper">
            <div className="student_box" ref={listRef}>
              {(getStaffByNameFetching || getStaffByNameLoading) && (
                <div className="loading_container">
                  <CircularProgress color="primary" size={24} />
                </div>
              )}
              {isNavigateToProfile
                ? state.staffData?.list?.map((item, ind) => (
                    <Link
                      key={ind}
                      style={{ textDecoration: "none" }}
                      to={`/${appRoutes.staffProfile}/${item?.staffDocId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <StaffCard item={item} />
                    </Link>
                  ))
                : state.staffData?.list?.map((item, ind) => (
                    <Box
                      key={ind}
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        setState((prev) => ({
                          ...prev,
                          name: "",
                          isFocus: false,
                        }));
                        returnResponse(item);
                      }}
                    >
                      <StaffCard item={item} />
                    </Box>
                  ))}
              {state.staffData?.pages !== state.staffData?.page && (
                <Stack direction="row" justifyContent="center">
                  <Typography
                    sx={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      textAlign: "center",
                      display: "inline-block",
                      mb: 1,
                    }}
                    onClick={() =>
                      setState((prev) => ({ ...prev, page: prev.page + 1 }))
                    }
                  >
                    more
                  </Typography>
                </Stack>
              )}
            </div>
          </div>
        )}
      </Wrapper>
    </ClickAwayListener>
  );
};

export default StaffSeachDialogDashboard2;
const Wrapper = styled(Box)`
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: visible;
  z-index: 1;

  &:has(.custom_input:focus) {
    z-index: 10000;
  }

  .input_box {
    padding: 12px 16px;
    border: 2px solid rgba(2, 122, 233, 0.12);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: linear-gradient(145deg, #ffffff 0%, #f0f8ff 100%);
    border-radius: 12px;
    box-shadow: 0px 2px 8px rgba(2, 122, 233, 0.04);
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: rgba(2, 122, 233, 0.2);
      box-shadow: 0px 4px 16px rgba(2, 122, 233, 0.08);
      transform: translateY(-1px);
    }

    &:focus-within {
      border: 2px solid #027ae9;
      box-shadow: 0px 4px 16px rgba(2, 122, 233, 0.15);
      transform: translateY(-2px);
    }
  }

  .close_icon {
    font-size: 14px;
    color: rgba(2, 122, 233, 0.7);
    background: linear-gradient(145deg, #ffffff 0%, #f0f8ff 100%);
    cursor: pointer;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(2, 122, 233, 0.1);
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(145deg, #027ae9 0%, #0b5fbb 100%);
      color: white;
      transform: scale(1.1);
    }
  }

  .custom_input {
    width: 100%;
    outline: none;
    border: none;
    font-size: 15px;
    font-weight: 500;
    height: 24px;
    background: transparent;
    color: #027ae9;
    letter-spacing: 0.01em;

    &::placeholder {
      color: rgba(2, 122, 233, 0.5);
      font-weight: 400;
    }
  }

  .student_box__wrapper {
    position: absolute;
    width: min(420px, 90vw);
    max-width: 420px;
    max-height: 380px;
    padding-top: 8px;
    z-index: 9999;
    left: 0;
    top: 100%;
    right: auto;

    @media (max-width: 600px) {
      width: min(350px, 90vw);
      left: -10px;
    }

    .student_box {
      padding: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(145deg, #ffffff 0%, #f0f8ff 100%);
      border-radius: 16px;
      border: 1px solid rgba(2, 122, 233, 0.12);
      box-shadow: 0px 8px 32px rgba(2, 122, 233, 0.15),
        0px 4px 16px rgba(0, 0, 0, 0.08);
      backdrop-filter: blur(20px);
      overflow-y: auto;
      max-height: 380px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(2, 122, 233, 0.05);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: linear-gradient(145deg, #027ae9 0%, #0b5fbb 100%);
        border-radius: 10px;

        &:hover {
          background: linear-gradient(145deg, #0b5fbb 0%, #027ae9 100%);
        }
      }
    }
  }

  .loading_container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
  }
`;
